import { AxiosError } from 'axios'

export const isAxiosError = (error: unknown): error is AxiosError =>
  Object.prototype.hasOwnProperty.call(error, 'config')
